import { render, staticRenderFns } from "./index_ws.vue?vue&type=template&id=3919f767&scoped=true"
import script from "./index_ws.vue?vue&type=script&lang=js"
export * from "./index_ws.vue?vue&type=script&lang=js"
import style0 from "./index_ws.vue?vue&type=style&index=0&id=3919f767&prod&lang=css"
import style1 from "./index_ws.vue?vue&type=style&index=1&id=3919f767&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3919f767",
  null
  
)

export default component.exports